import { PayloadAction } from '@reduxjs/toolkit';
import { SelectOption } from '@/features/editMode/types/selectOption';
import { HttpServiceResponse } from '@/services/HttpService/types';
import { call, put, takeLatest } from 'redux-saga/effects';
import HttpService from '@/services/HttpService/HttpService';
import {
  getCountriesList,
  getStatesList,
  setCountriesListLoadingStatus,
  setStatesListLoadingStatus,
  updateCountriesList,
  updateStatesList,
} from '../store/geographySlice';

function* getCountriesListSaga() {
  try {
    yield put(setCountriesListLoadingStatus(true));
    const { data }: HttpServiceResponse<SelectOption[]> = yield call(HttpService.get, `/examiner/Geography/countries`);
    yield put(updateCountriesList(data));
  } catch (error) {
    console.error(error);
  } finally {
    yield put(setCountriesListLoadingStatus(false));
  }
}

function* getStatesListSaga({ payload }: PayloadAction<string>) {
  try {
    yield put(setStatesListLoadingStatus(true));
    const searchParams = payload ? `?countryCode=${payload}` : '';
    const { data }: HttpServiceResponse<SelectOption[]> = yield call(
      HttpService.get,
      `/examiner/Geography/country-states${searchParams}`,
    );
    yield put(updateStatesList(data));
  } catch (error) {
    console.error(error);
  } finally {
    yield put(setStatesListLoadingStatus(false));
  }
}

export function* geographyWatcher() {
  yield takeLatest(getCountriesList.type, getCountriesListSaga);
  yield takeLatest(getStatesList.type, getStatesListSaga);
}
